import { render } from "./ManagementPanel.vue?vue&type=template&id=738b3880&scoped=true"
import script from "./ManagementPanel.vue?vue&type=script&lang=js"
export * from "./ManagementPanel.vue?vue&type=script&lang=js"

import "./ManagementPanel.vue?vue&type=style&index=0&id=738b3880&scoped=true&lang=scss"

import exportComponent from "/builds/blat/bcard-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-738b3880"]])

export default __exports__